/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/magnific.js');
import { marqueeText } from './marqueeText.js';

export function people() {
  $('.team__popupLink').magnificPopup({
    type: 'inline',
    midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    gallery: {
      enabled: true
    },
    callbacks: {
      open: function() {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          marqueeText();
        }, 50);
      }
    }
  });
}
